const GTM_ID = "GTM-TWLG5MNK";
const GTM_SCRIPT_ID = "gtm-script";

const getGTMScripts = () => {
  if (typeof document === "undefined") {
    return [];
  }

  return Array.from(
    document.querySelectorAll(`script[src*="googletagmanager.com/gtm.js?id=${GTM_ID}"]`)
  );
};

export const initializeGTM = ({ forceReload = false } = {}) => {
  if (typeof window === "undefined" || typeof document === "undefined") {
    return;
  }

  window.dataLayer = window.dataLayer || [];

  const existingScript = document.getElementById(GTM_SCRIPT_ID) ||
    document.querySelector(`script[src*="googletagmanager.com/gtm.js?id=${GTM_ID}"]`);

  if (existingScript && !forceReload) {
    return;
  }

  if (forceReload) {
    getGTMScripts().forEach((script) => script.parentNode?.removeChild(script));
  }

  window.dataLayer.push({
    "gtm.start": new Date().getTime(),
    event: "gtm.js",
  });

  const script = document.createElement("script");
  script.id = GTM_SCRIPT_ID;
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}&cb=${Date.now()}`;
  document.head.appendChild(script);
};

export const trackPageView = (path, referrer = "") => {
  if (typeof window === "undefined" || typeof document === "undefined") {
    return;
  }

  const eventTimestamp = new Date().toISOString();

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "page_view",
    event_id: `page_view_${Date.now()}`,
    event_timestamp: eventTimestamp,
    page_path: path,
    page_location: `${window.location.origin}${path}`,
    page_title: document.title,
    page_referrer: referrer,
  });
};
